import { axiosInstance as Send } from '../axiosInstance'
import { responseType } from '../type'
import constants from '../../constants'
import { HistoryRes } from './response'
import config from '../../config'

export const getHistory = async (): Promise<responseType<HistoryRes>> => {
  const url = `${constants.prefix}/${constants.versioning}/transaction/history`
  return Send.get<responseType<HistoryRes>>(`${config.EXPLORER_BACKEND_URL + url}`).then((response) => response.data)
}
